module.exports = __webpack_public_path__ + "static/media/forms.022aaa98.svg";